// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/views/partner/partnerTournament/eventsTable.module.css
// module id = 2289
// module chunks = 0